import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Typography from '@mui/material/Typography';


export default function RelatorioBoletimEletivaWeb({ boletimEscolar }) {

    return (
        <>
            <Typography
                style={{
                    textAlign: 'center',
                    textDecoration: 'underline'
                }}
                variant="h6">
                Projetos (PBL)
            </Typography>
            <Table size="small" aria-label="a dense table">
                <TableHead>
                    <TableRow>
                        <TableCell>Disciplinas</TableCell>
                        <TableCell>Conceito Final</TableCell>
                        <TableCell>Faltas</TableCell>
                        <TableCell>AC</TableCell>
                        <TableCell>Carga Horária</TableCell>
                        <TableCell>Frequência(%)</TableCell>
                    </TableRow>
                </TableHead>

                <TableBody>
                    {boletimEscolar.bprojetos.map((bep, index) => (
                        <TableRow key={index}>
                            <TableCell>{bep.tdp.disciplina.descricao}</TableCell>
                            <TableCell>{bep.conceitoFinal && bep.conceitoFinal.conceito ? bep.conceitoFinal.conceito.descricao : '--'}</TableCell>
                            <TableCell>{bep.totalFaltas ? bep.totalFaltas : '--'}</TableCell>
                            <TableCell>{bep.ausenciaCompensada ? bep.ausenciaCompensada : '--'}</TableCell>
                            {/* <TableCell>{bep.tdp.cargaHoraria ? bep.tdp.cargaHoraria : '--'}</TableCell> */}
                            <TableCell>{bep.totalAulas}</TableCell>
                            <TableCell>{bep.frequencia}</TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
        </>
    );
}